import { Part } from './Part';
import { PartList } from './ScorePart';
import { XMLElementParser } from './XMLElementParser';
export class ScorePartwise extends XMLElementParser {
    get partList() {
        const node = this.node.elements?.find(e => e.name === 'part-list');
        return node ? new PartList(node) : undefined;
    }
    get parts() {
        const scoreParts = this.partList?.parts;
        const nodes = this.node.elements?.filter(e => e.name === 'part') ?? [];
        return nodes.map(node => new Part(node, scoreParts));
    }
}
//# sourceMappingURL=ScorePartwise.js.map